import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import UnStyledImage from "./image";
import Hidden from "./hidden";

const HeroImage = styled(UnStyledImage)`
  height: 100%;
  width: 100%;
  object-fit: cover;
  position: absolute;
  z-index: 0;
  @media (max-width: ${({ theme }) => theme.breakpoints.phone}) {
    position: relative;
  }
`;

const HeroVideo = styled.video`
  height: 100%;
  width: 100%;
  object-fit: cover;
  position: absolute;
  z-index: 0;
`;

const Media = ({ className, media, loading, objectFit }) => {
  return media?.mimeType?.match(/^video/) ? (
    <HeroVideo className={className} autoPlay loop muted playsInline>
      <source
        src={media.localFile.publicURL}
        type={media.mimeType}
        alt={media.mediaAlt}
      />
    </HeroVideo>
  ) : (
    <HeroImage
      className={className}
      image={media}
      loading={loading}
      objectFit={objectFit}
    />
  );
};

Media.propTypes = {
  className: PropTypes.string,
  media: PropTypes.object,
  loading: PropTypes.oneOf(["eager", "lazy"]),
  objectFit: PropTypes.string,
};

const MediaWithArtDirection = ({
  className,
  media,
  mobileMedia,
  loading = "lazy",
  objectFit,
}) => {
  if (!mobileMedia) {
    return (
      <Media
        className={className}
        media={media}
        loading={loading}
        objectFit={objectFit}
      />
    );
  }
  return (
    <>
      {media && (
        <Hidden $showOnDesktop={true} $showOnTablet={true} $showOnPhone={false}>
          <Media
            className={className}
            media={media}
            loading={loading}
            objectFit={objectFit}
          />
        </Hidden>
      )}
      <Hidden $showOnDesktop={false} $showOnTablet={false} $showOnPhone={true}>
        <Media
          className={className}
          media={mobileMedia}
          loading={loading}
          objectFit={objectFit}
        />
      </Hidden>
    </>
  );
};

MediaWithArtDirection.propTypes = {
  className: PropTypes.string,
  media: PropTypes.object,
  mobileMedia: PropTypes.object,
  loading: PropTypes.oneOf(["eager", "lazy"]),
  objectFit: PropTypes.string,
};

export default MediaWithArtDirection;
